(function () {
  function escapeHtml(text) {
    const el = document.createElement('div');
    el.textContent = text == null ? '' : String(text);
    return el.innerHTML;
  }

  function buildRow(line) {
    const ref = line.ref_number ? escapeHtml(line.ref_number) : '&nbsp;';

    if (line.missing) {
      return (
        '<div class="mpv2-row">' +
        '<div class="mpv2-ref">' + ref + '</div>' +
        '<div class="mpv2-thumb">&nbsp;</div>' +
        '<div class="mpv2-part"><span class="mpv2-title">Item No Longer Available</span></div>' +
        '<div class="mpv2-price">&nbsp;</div>' +
        '<div class="mpv2-qty">&nbsp;</div>' +
        '<div class="mpv2-action">&nbsp;</div>' +
        '</div>'
      );
    }

    const img = line.image_url
      ? '<a href="' + escapeHtml(line.url) + '"><img class="lazyload img-responsive" src="' +
        escapeHtml(line.image_url) +
        '" alt="' +
        escapeHtml(line.image_alt || line.title) +
        '" loading="lazy" /></a>'
      : '&nbsp;';

    let skuBlock = '';
    if (line.sku || line.supersede) {
      skuBlock =
        '<div class="mpv2-sku">' +
        (line.sku ? escapeHtml(line.sku) : '') +
        (line.supersede
          ? '<span class="mpv2-supersede">' + escapeHtml(line.supersede) + '</span>'
          : '') +
        '</div>';
    }

    const hideCommerce = line.is_placeholder;
    const qtyDefault = line.qty_needed != null ? line.qty_needed : 1;
    const inputId = 'mpv2-qty-app-' + line.position + '-' + line.child_product_id;

    const priceBlock = hideCommerce
      ? '<div class="mpv2-price">&nbsp;</div>'
      : '<div class="mpv2-price"><strong class="money">' +
        escapeHtml(line.price_formatted || '') +
        '</strong></div>';

    let qtyBlock;
    if (hideCommerce) {
      qtyBlock =
        '<div class="mpv2-qty">&nbsp;</div><div class="mpv2-action">&nbsp;</div>';
    } else {
      qtyBlock =
        '<div class="mpv2-qty">' +
        '<form method="post" action="/cart/add" class="mpv2-add" data-schematic-add>' +
        '<input type="hidden" name="id" value="' +
        escapeHtml(line.variant_id) +
        '" />' +
        '<label class="visually-hidden" for="' +
        inputId +
        '">Quantity</label>' +
        '<input id="' +
        inputId +
        '" class="mpv2-qty-input" type="number" name="quantity" min="1" step="1" value="' +
        escapeHtml(qtyDefault) +
        '" aria-label="Quantity" inputmode="numeric" pattern="[0-9]*" />' +
        '<input type="submit" name="add" class="btn_c varprod-submit" value="Add" />' +
        '</form></div><div class="mpv2-action">&nbsp;</div>';
    }

    return (
      '<div class="mpv2-row">' +
      '<div class="mpv2-ref">' + ref + '</div>' +
      '<div class="mpv2-thumb">' + img + '</div>' +
      '<div class="mpv2-part"><a class="mpv2-title" href="' +
      escapeHtml(line.url) +
      '">' +
      escapeHtml(line.title) +
      '</a>' +
      skuBlock +
      '</div>' +
      priceBlock +
      qtyBlock +
      '</div>'
    );
  }

  function bindAjaxAdd(root) {
    root.querySelectorAll('form[data-schematic-add]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function (err) {
            console.error(err);
            form.submit();
          })
          .finally(function () {
            if (submit) submit.disabled = false;
          });
      });
    });
  }

  function loadSchematicParts(root) {
    var proxyUrl = root.dataset.proxyUrl;
    var productId = root.dataset.productId;
    var statusEl = root.querySelector('[data-schematic-status]');
    var listEl = root.querySelector('[data-schematic-lines]');

    if (!proxyUrl || !productId) return;

    var url = new URL(proxyUrl, window.location.origin);
    url.searchParams.set('product_id', productId);

    fetch(url.toString(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return {};
          }).then(function (payload) {
            throw new Error(payload.error || 'Request failed (' + response.status + ')');
          });
        }
        return response.json();
      })
      .then(function (data) {
        var heading = root.querySelector('[data-schematic-heading]');
        if (heading && data.heading) heading.textContent = data.heading;

        if (!data.lines || !data.lines.length) {
          if (statusEl) {
            statusEl.textContent =
              'No parts list has been imported for this schematic yet.';
            statusEl.hidden = false;
          }
          return;
        }

        if (statusEl) statusEl.hidden = true;
        listEl.innerHTML = data.lines.map(buildRow).join('');
        bindAjaxAdd(root);

        if (data.warnings && data.warnings.length && statusEl) {
          statusEl.hidden = false;
          statusEl.classList.add('mpv2-import-warnings');
          statusEl.textContent =
            data.warnings.length + ' part(s) could not be matched to a product.';
        }
      })
      .catch(function (error) {
        console.error('Schematic parts load failed', error);
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent =
            'Unable to load the parts list right now. Please refresh or contact support.';
        }
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-schematic-parts-app]').forEach(loadSchematicParts);
  });
})();

